import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';

import CTAButton from '../../CTAButton';

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
  .oc-cta-button {
    margin-right: 5%;
  }
`;

const TabControls = ({ isLast, onNext, onPrevious, isFirst, t }) => (
  <ButtonContainer>
    {!isFirst && <CTAButton type="button" href="#" onClick={onPrevious} text={t('previous')} />}
    {!isLast && <CTAButton type="button" href="#" onClick={onNext} text={t('next')} />}
    {isLast && <CTAButton className="oc-cta-button" element="button" text={t('submit')} type="submit" />}
  </ButtonContainer>
);

TabControls.propTypes = {
  isLast: PropTypes.bool,
  isFirst: PropTypes.bool,
  onPrevious: PropTypes.func,
  onNext: PropTypes.func,
  t: PropTypes.func,
};

TabControls.defaultProps = {
  isLast: false,
  isFirst: false,
  onNext: () => {},
  onPrevious: () => {},
  t: () => {},
};

export default TabControls;
